import utils from '@/mixins/utils.js'

export const dataFields = {
  Nome: 'no_cidadao',
  'Data de nascimento': 'dt_nascimento',
  Mãe: 'no_mae',
  MA: 'micro_area',
  Avaliado: {
    field: 'dt_atendimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : 'Auto referido'
    },
  },
  PA: {
    field: 'dt_pa_2',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
}

export const chartOptions = {
  chart: {
    height: 300,
    type: 'line',
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'straight',
    width: 2,
  },
  title: {
    text: 'CONSULTAS EM HIPERTENSOS E AFERIÇÃO DE PA',
    align: 'center',
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
      opacity: 0.5,
    },
  },
  xaxis: {
    categories: [],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center',
  },
  markers: {
    size: 5,
  },
  annotations: {
    yaxis: [
      {
        y: 50,
        y2: 100,
        borderColor: '',
        fillColor: '#9dc8e1',
        label: {
          text: '',
        },
      },
      {
        y: 0,
        y2: 49,
        borderColor: '',
        fillColor: '#ffcccc',
        label: {
          text: '',
        },
      },
    ],
  },
  colors: ['#008FFB', '#ff9933', '#28a745'],
}
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
/* ---------------------------------------------------------- */
export const municipioBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  xaxis: {
    categories: [
      'Denominador estimado',
      'Denominador informado',
      'Numerador',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#159794', '#8fce02', '#ffaa19', '#ff0000', '#00a4de', '#e3e2e2'],
}

export const municipioCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
                  const valor = (val / 10).toFixed(2)
                  return valor
                } */
        },
      },
    },
  },
  /*  stroke: {
            lineCap: 'round'
          }, */
  /*   colors: ['#9725b0'] */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 50) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}

export const equipeBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  /* xaxis: {
          categories: [
            '',
            '',
            '',
            '',
            ''
          ]
        }, */
  xaxis: {
    categories: [
      'Denominador informado',
      'Numerador',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#8fce02', '#ffaa19', '#ff0000', '#00a4de', '#e3e2e2'],
}

export const equipeCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
                  const valor = (val / 10).toFixed(2)
                  return valor
                } */
        },
      },
    },
  },
  /*  stroke: {
            lineCap: 'round'
          }, */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 50) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}
export const acsBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  /* xaxis: {
          categories: [
            '',
            '',
            '',
            '',
            ''
          ]
        }, */
  xaxis: {
    categories: [
      'Denominador informado',
      'Numerador',
      'Faltam',
      'Meta Quadrimestral (%)',
      'Meta Semanal',
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#8fce02', '#ffaa19', '#ff0000', '#00a4de', '#e3e2e2'],
}

export const acsCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          /*      color: '#9e9e9e', */
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
          /* formatter: function(val) {
                  const valor = (val / 10).toFixed(2)
                  return valor
                } */
        },
      },
    },
  },
  /*  stroke: {
            lineCap: 'round'
          }, */
  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 50) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}
